/**
 * The S3 key behind a download link. Presigned links to the same object differ in query string on
 * every regeneration (and can differ in host after a bucket move), so compare objects by this.
 */
export const s3KeyOf = (url) => {
    try {
        return decodeURIComponent(new URL(url).pathname);
    }
    catch {
        return url;
    }
};
